import h1 from "../assets/pictures/about/p4.jpeg";
import logo from "../assets/logos/RG copy 2.png";
import s3 from "../assets/pictures/home/grid3.jpeg";
import DesktopWa from "../components/DesktopWa";
import Call from "../components/Call";

export default function Legacy() {
  return (
    <>
      <img src={h1} className=" w-full xl:h-[500px] h-[500px] object-cover" />

      <p className=" mt-[30px] text-[14px] font-[description1] xl:pl-[380px] xl:pr-[380px] text-center pl-[20px] pr-[20px]">
        Through our lens, we honor the legacy of culture capturing its essence
        with depth, respect, and artistic grace. Every ritual, every expression,
        every sacred tradition is framed with intention, telling a story that
        goes beyond visuals. <br />
        <br />
        From the vibrant textures of attire to the silent strength of ancestral
        customs, we preserve not just images, but the soul of heritage itself.
        Our craft becomes a bridge between generations, where culture is not
        just remembered it’s relived.
      </p>
      <div className="flex justify-center mb-[40px]">
        <img src={logo} className="w-[70px] h-[70px] object-contain" />
      </div>
      <div className="flex xl:justify-center xl:items-center pl-[20px] pr-[20px] xl:pl-0 xl:pr-0 mb-[40px]">
        <img
          src={s3}
          className="w-full h-[500px] xl:w-[600px] xl:h-[600px] object-cover "
        />
      </div>
      <p className="mb-[50px]  text-[14px] font-[description1] xl:pl-[380px] xl:pr-[380px] text-center pl-[20px] pr-[20px]">
        Authentic, unscripted emotions, laughter, tears, glances captured
        without posing. This rawness is what modern couples crave.
      </p>

      <div className="flex xl:justify-center xl:items-center pl-[20px] pr-[20px] xl:pl-0 xl:pr-0 mb-[40px]">
        <img
          src={s3}
          className="w-full h-[500px] xl:w-[600px] xl:h-[600px] object-cover "
        />
      </div>
      <p className="mb-[40px] text-[14px] font-[description1] xl:pl-[380px] xl:pr-[380px] text-center pl-[20px] pr-[20px]">
        Highlighting heritage, rituals, and traditions with visual richness and
        storytelling. Especially trending in destination and luxury weddings.
      </p>
      <div className="flex xl:justify-center xl:items-center pl-[20px] pr-[20px] xl:pl-0 xl:pr-0 mb-[30px] ">
        <img
          src={s3}
          className="w-full h-[500px] xl:w-[600px] xl:h-[600px] object-cover "
        />
      </div>
      <p className="mb-[50px]  text-[14px] font-[description1] xl:pl-[380px] xl:pr-[380px] text-center pl-[20px] pr-[20px]">
        Deep focus on rituals, heritage, and legacy, a celebration of roots.
      </p>
      <div className="chat-icon">
        <DesktopWa />
      </div>
      <div className="chat-icon1">
        <Call phoneNumber="9980685056" />
      </div>
    </>
  );
}
